var app = angular.module("leonardo");

var DynamicFormListController = function($scope, $state, $controller, $q, ngDialog, AccountUserService, PermissionService,
                                         DynamicFormRestService, NotificationService, FilterService, AuthService,
                                         SectorRestService, FolderService, $rootScope, AuthDataService, AccountService) {

  $scope.permissionService = PermissionService;
  $scope.currentFolder = {};
  $scope.authDataService = AuthDataService;

  $scope.folders = [];
  $scope.dynamic_forms = [];
  $scope.dynamic_folders = [];
  $scope.folders_groups = {};
  $scope.dfIdEditing = 0;
  $scope.dfNameEditing = '';

  $scope.getEntitiesPromise = function(options) {
    var defer = $q.defer();
    options.search = FilterService.getFilter('search');
    options.sector = FilterService.getFilter('sector');
    options.origin = FilterService.getFilter('origin');
    options.account = FilterService.getFilter('account_reports');
    options.client_instance = FilterService.getFilter('client_instances', true);
    options.managed_by = FilterService.getFilter('managed_by_reports');
    options.summary = true;

    var filters = {
      disable_pagination: true,
      search: FilterService.getFilter('search'),
      sector: FilterService.getFilter('sector'),
      origin: FilterService.getFilter('origin'),
      account: FilterService.getFilter('account_reports'),
      client_instance: FilterService.getFilter('client_instances', true),
      managed_by: FilterService.getFilter('managed_by_reports'),
      summary: true
    };

    var promises = [];
    $scope.folders = [];
    $scope.dynamic_forms = [];
    $scope.dynamic_folders = [];
    $scope.folders_groups = {};

    if(options.search){
      $scope.loadingDynamicForms = true;
      $scope.loadingFolders = true;
      if($state.params.pk){
        filters['parent'] = $state.params.pk;
      }
      else {
        filters['purpose'] = FolderService.PURPOSE_DYNAMIC_FORMS;
      }
       FolderService.getlist(filters, true).then(function(data) {
        $scope.folders = data.results ? data.results : data;
        $scope.folders_groups = {};
        $scope.folders.sort(function (a, b) {
          return a.account > b.account;
        });
        angular.forEach($scope.folders, function (folder) {
          if (!$scope.folders_groups[folder.account])
            $scope.folders_groups[folder.account] = [];
          $scope.folders_groups[folder.account].push(folder);
        });
        $scope.loadingFolders = false;
       }).finally(function() {
        $scope.loadingFolders = false;
      });

       DynamicFormRestService.getlist(options, true).then(function (response) {
        $scope.dynamic_forms = response.results ? response.results : response;
        defer.resolve($scope.dynamic_forms);
       }).finally(function() {
        $scope.loadingDynamicForms = false;
      });

    }
    else{
      $scope.loadingDynamicForms = true;
      $scope.loadingFolders = true;
      if ($state.params.pk) {
        options.folder = $state.params.pk;
        filters['parent'] = $state.params.pk;
        FolderService.get($state.params.pk, true).then(function (folder) {
          $scope.currentFolder = folder;
          $rootScope.$broadcast('folder:loaded', folder);
          $scope.dynamic_folders = [folder];
        });
        var defer_folders = $q.defer();
        promises.push(defer_folders.promise);
        FolderService.getlist(filters, true).then(function(data) {
          $scope.folders = data.results ? data.results : data;
          defer_folders.resolve();
        }, function() {
          $scope.folders = [];
          defer_folders.resolve();
        });
        var defer_dynamic = $q.defer();
        promises.push(defer_dynamic.promise);
        DynamicFormRestService.getlist(options).then(function (data) {
          $scope.dynamic_forms = data.results ? data.results : data;
          DynamicFormRestService.optionsForExportContent = angular.copy(options);
          defer_dynamic.resolve();
        }, function() {
          $scope.dynamic_forms = [];
          defer_dynamic.resolve();
        });
        resolvePromises();
      }
      else {
        filters['purpose'] = FolderService.PURPOSE_DYNAMIC_FORMS;
        FolderService.getlist(filters, true).then(function (data) {
          var results = data.results ? data.results : data;
          $scope.dynamic_folders = angular.copy(results);
          $scope.folders = [];
          $scope.dynamic_forms = [];
          var folder_ids = [];
          var defer_array = [];
          angular.forEach(results, function (result, key) {
            filters['parent'] = result.id;
            delete(filters['purpose']);
            folder_ids.push(result.id);
            defer_array[key] = $q.defer();
            promises.push(defer_array[key].promise);
            FolderService.getlist(filters, true).then(function (response) {
              $scope.folders = $scope.folders.concat(response.results ? response.results : response);
              defer_array[key].resolve();
            }, function() {
              $scope.folders = [];
              defer_array[key].resolve();
            });
          });
          if(!filters['search']){
            options.folder = folder_ids.join(',');
          }
          var defer_dynamic_form = $q.defer();
          promises.push(defer_dynamic_form.promise);
          DynamicFormRestService.getlist(options, true).then(function (response) {
            $scope.dynamic_forms = response.results ? response.results : response;
            DynamicFormRestService.optionsForExportContent = angular.copy(options);
            defer_dynamic_form.resolve();
          }, function() {
            $scope.dynamic_forms = [];
            defer_dynamic_form.resolve();
          });
          resolvePromises();
        });
      }

    }

    function resolvePromises(){
      $q.all(promises).then(function () {
        $scope.folders.sort(function (a, b) {
          return a.account > b.account;
        });
        angular.forEach($scope.folders, function (folder) {
          if (!$scope.folders_groups[folder.account])
            $scope.folders_groups[folder.account] = [];
          $scope.folders_groups[folder.account].push(folder);
        });
        $scope.loadingDynamicForms = false;
        $scope.loadingFolders = false;
        defer.resolve($scope.dynamic_forms);
      });
    }

    return defer.promise;
  };

  $scope.onEditFolder = function(folder) {
    ngDialog.open({
      template: 'views/templates/dialog/folder/add.html',
      controller: 'FolderAddDialog',
      data: {
        entity: folder,
        action: 'edit'
      }
    });
  };

  $scope.onMoveFolder = function(folder) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/folder/selector.html',
      controller: 'FolderSelectorDialog',
      data: {
        excludeFolder: folder.id,
        sector: $scope.getSector(),
        account: folder.account,
        rootDisabled: true
      }
    }).then(function(data) {
      var destiny = data ? data.destiny.id : null;
      if (data.action === 'move') {
        folder.moveTo({to_folder: destiny}).then(function() {
          $scope.loadPage($scope.page);
        });
      }
      else {
        folder.copyTo({to_folder: destiny}).then(function() {
          $scope.loadPage($scope.page);
        });
      }
    });
  };

  $scope.onDeleteFolder = function(folder) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: folder,
        type: 'folder',
        title: 'Delete Folder ' + folder.name
      }
    }).then(function(){
      $scope.loadPage($scope.page);
    });
  };

  $scope.canEdit = function (folder) {
    var can = false;
    var role_id = null;
    if (folder) {
      var account_user = AccountUserService.getAccountUser(folder.account);
      if (account_user) role_id = account_user.role ? account_user.role.id : account_user.role;
      if (PermissionService.isOwner(account_user))
        can = true;
      else if (folder.property) {
        angular.forEach(account_user.properties, function(property) {
          if (property.id == folder.property) {
            if (folder.editable_by_roles && (folder.editable_by_roles.length > 0))
              can = _.contains(folder.editable_by_roles, role_id);
            else
              can = true;
          }

        });
      }
      else if (folder.portfolio) {
        angular.forEach(account_user.portfolios, function(portfolio) {
          if (portfolio.id == folder.portfolio)
            if (folder.editable_by_roles && (folder.editable_by_roles.length > 0))
              can = _.contains(folder.editable_by_roles, role_id);
            else
              can = true;
        });
      }
      else {
        if (folder.editable_by_roles && (folder.editable_by_roles.length > 0))
          can = _.contains(folder.editable_by_roles, role_id);
        else
          can = true;
      }
    }
    return can;
  };

  $scope.goToFolder = function(folder, documents) {
    var url = 'documents.dynamic-forms-folder';
    if (documents) {
      url = 'documents.list';
    }
    let id = null;
    if(folder){
      id = folder.id ? folder.id : folder;
    }
    if (id === $scope.currentFolder.id) return;
    $state.go(url, {pk: id});
  };

  $scope.managers = function (dynamicForm) {
    var managers = '';
    if (angular.isArray(dynamicForm.managed_by)) {
      angular.forEach(dynamicForm.managed_by, function (value) {
        managers += value.name + ', ';
      });
      managers = managers.slice(0, -2);
    }
    else
      managers = dynamicForm.managed_by ? dynamicForm.managed_by.name : 'Only Owner';
    return managers;
  };

  $scope.editName = function(df){
    $scope.dfIdEditing = df.id;
    $scope.dfNameEditing = angular.copy(df.name);
  };

  $scope.submitName = function(index, dfNameEditing){
    var df = $scope.tableFilterCollection.results[index];
    DynamicFormRestService.getlist({ account: df.account, name__iexact: dfNameEditing}).then(function (data) {
      var results = data.results || data;
      var sameIds = results.filter(function (item) {
        return item.id === df.id;
      });
      if (results.length === sameIds.length) {
        df.patch({name: dfNameEditing}).then(function (result) {
          $scope.tableFilterCollection.results[index].name = result.name;
          $scope.dfIdEditing = 0;
        });
      }
      else {
        NotificationService.error('This dynamic form already exists.');
      }
    });
  };

  $scope.cancelNameEdit = function(){
    $scope.dfIdEditing = 0;
  };

  $scope.edit = function(id){
    var params = {pk:id};
    params.folder = $state.params.pk ? $state.params.pk : null;
    $state.go('documents.dynamic-forms.edit', params);
  };

  $scope.getSector = function() {
    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
      if(FilterService.hasFilter('sector')){
        return FilterService.getFilter('sector');
      }
      return ((SectorRestService.getCollection().length > 0) ? SectorRestService.getCollection()[0].id : null);
    }
    return null;
  };

  $scope.showMoveDialog = function(dynamic_form) {
    FolderService.getlist({
      purpose: FolderService.PURPOSE_DYNAMIC_FORMS,
      account: dynamic_form.account
    }).then(function(data) {
      var folder = null;
      var allfolder = null;
      if (data.length > 0)
        folder = data[0];
        allfolder = data;
      ngDialog.openConfirm({
        template: 'views/templates/dialog/folder/selector.html',
        controller: 'FolderSelectorDialog',
        data: {
          rootFolder: folder,
          excludeFolder: [dynamic_form.folder, folder.id],
          sector: $scope.getSector(),
          action: 'select',
          only_dynamic: true,
          folder: folder,
          account: dynamic_form.account,
          allfolder: allfolder
        }
      }).then(function (res) {
        var destiny = res ? res.destiny.id : null;
        // if (res.action === 'move')
          dynamic_form.patch({folder: destiny}).then(function () {
            $scope.loadPage($scope.page);
          });
        // else
        //   dynamic_form.copyTo({to_folder: destiny}).then(function () {
        //     $scope.loadPage($scope.page);
        //   });
      });
    });
  };

  $scope.showDeleteDialog = function (dynamic_form) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: dynamic_form,
        type: 'dynamic form'
      }
    }).then(function(){
      $scope.loadPage($scope.page);
    });
  };

  $scope.openCloneDialog = function (dynamic_form, workAsUser) {
    DynamicFormRestService.get(dynamic_form.id).then(function(result) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/dynamic-form/clone.html',
        controller: 'DynamicFormCloneDialog',
        data: {
          dynamic_form: result
        }
      }).then(function (data) {
        if (workAsUser) {
          var token = 'jwt ' + AuthService.getOldToken();
          dynamic_form.cloneToAccount({accounts: dynamic_form.accounts, name: data.name}, undefined, {'Authorization': token}).then(function() {
            NotificationService.notify('success', 'The dynamic-form has been cloned correctly');
          });
        }
        else {
          let newdata = {...data, languages : data.languages.map(v => { return v.id})}
          DynamicFormRestService.post(newdata).then(function (resp) {
            $scope.loadPage($scope.page);
          });
        }
      });
    });
  };

  $scope.showCloneAdminDialog = function (dynamic_form) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/admin/clone-element.html',
      controller: 'CloneTypeDialog',
      className: 'ngdialog-theme-default ngdialog-select-account',
      data: {
        type: 'dynamic form',
      }
    }).then(function (result) {
      if (result.type_result === 'client_instance') {
        dynamic_form.cloneToWhiteLabel({clientinstances: result.client_instance}).then(function () {
          $scope.loadPage($scope.page);
        });
      }
      else {
        $scope.openCloneDialog(dynamic_form);
      }
    });
  };

  $scope.showCloneToAccountDialog = function (dynamic_form) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/account/select.html',
      controller: 'SelectAccountDialog',
      className: 'ngdialog-theme-default ngdialog-select-account',
      data: {
        workAsUser: true,
        exclude: dynamic_form.account
      }
    }).then(function (account) {
      dynamic_form.accounts = account;
      $scope.openCloneDialog(dynamic_form, true);
    });
  };

  $scope.showCloneToSystemDialog = function (dynamic_form) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/dynamic-form/clone-system.html',
    }).then(function(data){
      var token = 'jwt ' + AuthService.getOldToken();
      dynamic_form.cloneToSystem(undefined, {'Authorization': token}).then(function() {
        NotificationService.notify('success', 'The dynamic-form has been cloned correctly');
      });
    });
  };

  $scope.showCloneDialog = function (dynamic_form) {
    if (AuthDataService.isAdmin()) {
      $scope.showCloneAdminDialog(dynamic_form);
    }
    else if ((AccountService.getCollection().length > 1) && !$state.params.folder) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account/select.html',
        controller: 'SelectAccountDialog',
        className: 'ngdialog-theme-default ngdialog-select-account',
        data: {
          permission: 'permission_add_dynamic_form'
        }
      }).then(function (account) {
        dynamic_form.account = account;
        $scope.openCloneDialog(dynamic_form);
      });
    }
    else {
      $scope.openCloneDialog(dynamic_form);
    }
  };

  $scope.$on('folder:created', function(){
    $scope.loadPage($scope.page);
  });
  $scope.$on('folder:updated', function(){
    $scope.loadPage($scope.page);
  });

  $scope.$watch('dynamic_folders', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      $rootScope.$broadcast('folders-dynamic:updated', newValue);
    }
  });

  $controller('TableFilterController', { $scope: $scope });
  $scope.loadPage($scope.page);
};

app.controller('DynamicFormListController', ['$scope', '$state', '$controller', '$q', 'ngDialog', 'AccountUserService',
  'PermissionService', 'DynamicFormRestService', 'NotificationService', 'FilterService', 'AuthService',
  'SectorRestService', 'FolderService', '$rootScope', 'AuthDataService', 'AccountService',
  DynamicFormListController]);
